<template>
  <v-banner
    v-if="show"
    app
    :icon="icons.mdiAlertCircleOutline"
    icon-color="red"
    class="mb-4 warning-banner"
    outlined
    >
    <mrx-translation :token="token"></mrx-translation>
  </v-banner>
</template>

<script>
  import icons from '@/mixins/icons'
  import { mapState } from 'pinia'
  import { usePartnerConfigStore } from '@/stores/partnerConfig'

  export default {
    mixins: [icons],
    name: 'warning',
    computed: {
      token() {
        switch (this.status) {
          case 'demo':
            return 'app.warning.demo_mode'
          case 'training':
            return 'app.warning.training_mode'
          default:
            return null
        }
      },
      show() {
        return this.token !== null
      },
      ...mapState(usePartnerConfigStore, ['status']),
    },
  }
</script>

<style scoped>
</style>
